export enum EStatusType {
  OPPORTUNITY = 'OPPORTUNITY',
  WORK_ORDER = 'WORK_ORDER',
}
